// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import "./assets/style/reset.css";
import "./assets/style/common.css";
import axios from './package/axios.js';
import {imgUrl,menus,downloadFileUrl} from './package/api.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import css from 'swiper/dist/css/swiper.css'
Vue.use(axios);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.axios = axios;
Vue.prototype.imgUrl = imgUrl;
Vue.prototype.menus = menus;
Vue.prototype.downloadFileUrl = downloadFileUrl;
Vue.prototype.$bus = new Vue()
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js